<section class="ca-panel" [class.ca-compact]="compact" aria-label="Взаиморасчёты клиента">
  <header class="ca-header">
    <div class="ca-title">
      <mat-icon>account_balance_wallet</mat-icon><strong>Взаиморасчёты</strong>
    </div>
    <button mat-icon-button [disabled]="loading" (click)="reload()" aria-label="Обновить баланс">
      <mat-icon>refresh</mat-icon>
    </button>
  </header>
  <mat-form-field appearance="outline" class="ca-org"
    ><mat-label>Организация</mat-label
    ><mat-select [value]="orgId" (selectionChange)="selectOrg($event.value)"
      ><mat-option *ngFor="let org of organizations" [value]="org.id">{{
        org.name
      }}</mat-option></mat-select
    ></mat-form-field
  >
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <p class="ca-error" *ngIf="error" role="alert">{{ error }}</p>
  <button mat-button *ngIf="organizations.length > 1" [disabled]="loading" (click)="showOverview()">
    {{ overview ? 'К выбранной организации' : 'Все организации (просмотр)' }}
  </button>
  <section *ngIf="overview as all" class="ca-org-overview">
    <p class="ca-note">{{ all.note }}</p>
    <div class="ca-mini-summary">
      Сумма балансов: {{ all.totals.balance | number: '1.2-2' }} грн
    </div>
    <div *ngFor="let org of all.data" class="ca-overview-row">
      <b>{{ org.org_name }}</b
      ><span
        >Баланс {{ org.balance | number: '1.2-2' }} · доступно
        {{ org.available_credit | number: '1.2-2' }} · долг {{ org.debt | number: '1.2-2' }}</span
      >
    </div>
  </section>
  <ng-container *ngIf="overview ? null : summary as s">
    <div class="ca-balance" [class.ca-negative]="s.balance < 0" [class.ca-positive]="s.balance > 0">
      <span>Баланс клиента{{ blocked ? ' · предварительный' : '' }} · на сейчас</span
      ><strong
        >{{ s.balance > 0 ? '+' : '' }}{{ s.balance | number: '1.2-2' }} <small>грн</small></strong
      ><small>{{
        s.balance < 0
          ? 'Клиент должен нам'
          : s.balance > 0
          ? 'Свободные средства за вычетом долга'
          : 'Сальдо нулевое'
      }}</small>
    </div>
    <div class="ca-metrics">
      <div class="ca-positive">
        <span>Доступно</span><b>{{ s.available_credit | number: '1.2-2' }}</b>
      </div>
      <div>
        <span>В заказах</span><b>{{ s.committed_credit | number: '1.2-2' }}</b>
      </div>
      <div class="ca-negative">
        <span>Долг</span><b>{{ s.debt | number: '1.2-2' }}</b>
      </div>
      <div class="ca-pending">
        <span>В обработке</span><b>{{ s.reserved_credit | number: '1.2-2' }}</b>
      </div>
      <div class="ca-pending">
        <span>Ожидает банк</span><b>{{ s.pending_bank | number: '1.2-2' }}</b>
      </div>
      <div *ngIf="s.legacy_credit">
        <span>Не сверено</span><b>{{ s.legacy_credit | number: '1.2-2' }}</b>
      </div>
    </div>
    <p class="ca-note" *ngIf="s.legacy_credit">
      Историческая переплата показана справочно. В доступные средства она войдёт после подтверждения
      источников.
    </p>
    <p class="ca-warning" *ngIf="blocked">
      <mat-icon>info_outline</mat-icon><span>{{ blockedReason }}</span>
    </p>
    <p class="ca-warning" *ngIf="s.unassigned_documents">
      Документов без организации: {{ s.unassigned_documents }}. Они не включены в остатки; требуется
      распределение администратором.
    </p>
    <div class="ca-actions">
      <button mat-flat-button color="primary" [disabled]="blocked" (click)="action('TOPUP')">
        <mat-icon>add</mat-icon>Пополнить
      </button>
      <button
        mat-stroked-button
        [disabled]="blocked || s.available_credit <= 0"
        (click)="action('ALLOCATE')"
      >
        Оплатить заказ
      </button>
      <button
        mat-stroked-button
        [disabled]="blocked || s.available_credit <= 0"
        (click)="action('PAYOUT')"
      >
        Выдать деньги
      </button>
    </div>
    <a
      *ngIf="compact"
      mat-button
      [routerLink]="['/client/profile', clientId]"
      [queryParams]="{ tab: 'settlements' }"
      >Операции и акт сверки <mat-icon>arrow_forward</mat-icon></a
    >
    <ng-container *ngIf="!compact">
      <p class="ca-note">
        Деньги в заказах показаны отдельно. Пополнение не оплачивает заказы автоматически; зачёт
        выбирает менеджер.
      </p>
      <div class="ca-history-toolbar">
        <button mat-stroked-button (click)="filtersOpened = !filtersOpened">
          {{ filtersOpened ? 'Свернуть фильтры' : 'Фильтры и сортировка' }}</button
        ><button mat-stroked-button [disabled]="exporting" (click)="export('pdf')">
          Акт сверки PDF</button
        ><button mat-stroked-button [disabled]="exporting" (click)="export('csv')">
          Выгрузить CSV
        </button>
      </div>
      <form *ngIf="filtersOpened" class="ca-filters" (ngSubmit)="loadHistory(true)">
        <mat-form-field appearance="outline"
          ><mat-label>Период операций</mat-label
          ><mat-date-range-input [rangePicker]="range"
            ><input matStartDate [formControl]="dateFrom" /><input
              matEndDate
              [formControl]="dateTo" /></mat-date-range-input
          ><mat-datepicker-toggle matSuffix [for]="range"></mat-datepicker-toggle
          ><mat-date-range-picker #range></mat-date-range-picker
        ></mat-form-field>
        <mat-form-field appearance="outline"
          ><mat-label>Операция</mat-label
          ><mat-select [(ngModel)]="kind" name="kind"
            ><mat-option value="">Все</mat-option
            ><mat-option *ngFor="let value of kinds" [value]="value">{{
              kindLabel(value)
            }}</mat-option></mat-select
          ></mat-form-field
        >
        <mat-form-field appearance="outline"
          ><mat-label>Статус</mat-label
          ><mat-select [(ngModel)]="status" name="status"
            ><mat-option value="">Все</mat-option
            ><mat-option *ngFor="let value of statuses" [value]="value">{{
              statusLabel(value)
            }}</mat-option></mat-select
          ></mat-form-field
        >
        <mat-form-field appearance="outline"
          ><mat-label>Счёт №</mat-label
          ><input
            matInput
            type="number"
            min="1"
            [(ngModel)]="invoiceFilter"
            name="invoice" /></mat-form-field
        ><mat-form-field appearance="outline"
          ><mat-label>Сотрудник №</mat-label
          ><input matInput type="number" min="1" [(ngModel)]="actorFilter" name="actor"
        /></mat-form-field>
        <mat-form-field appearance="outline"
          ><mat-label>Сортировать по</mat-label
          ><mat-select [(ngModel)]="sort" name="sort"
            ><mat-option value="created_at">Дате</mat-option
            ><mat-option value="amount">Сумме</mat-option
            ><mat-option value="balance_after">Балансу</mat-option></mat-select
          ></mat-form-field
        ><mat-form-field appearance="outline"
          ><mat-label>Порядок</mat-label
          ><mat-select [(ngModel)]="direction" name="direction"
            ><mat-option value="desc">По убыванию</mat-option
            ><mat-option value="asc">По возрастанию</mat-option></mat-select
          ></mat-form-field
        >
        <button mat-stroked-button type="submit" [disabled]="historyLoading">Показать</button>
      </form>
      <div class="ca-period">
        <span
          >На начало периода
          <b>{{
            openingBalance === null ? 'Нет данных до сверки' : (openingBalance | number: '1.2-2')
          }}</b></span
        ><span
          >На конец периода
          <b>{{
            closingBalance === null ? 'Нет данных до сверки' : (closingBalance | number: '1.2-2')
          }}</b></span
        >
      </div>
      <mat-progress-bar *ngIf="historyLoading" mode="indeterminate"></mat-progress-bar>
      <div
        class="ca-history"
        (scroll)="edge($event)"
        tabindex="0"
        aria-label="История взаиморасчётов"
      >
        <article class="ca-history-row" *ngFor="let row of history">
          <div>
            <strong>{{ kindLabel(row.kind) }}</strong
            ><small
              >№{{ row.id }} ·
              {{ row.occurred_at || row.created_at || row.date | date: 'dd.MM.yyyy HH:mm' }}</small
            ><small *ngIf="row.actor_name || row.user_name">{{
              row.actor_name || row.user_name
            }}</small>
          </div>
          <div>
            <span class="ca-status" [class.ca-negative]="row.status === 'FAILED'">{{
              statusLabel(row.status)
            }}</span
            ><small *ngIf="row.reason">{{ row.reason }}</small
            ><small *ngIf="row.fiscal_status === 'PENDING'">Деньги учтены, чек ожидается</small
            ><small class="ca-error" *ngIf="row.fiscal_status === 'BLOCKED'"
              >Чек требует проверки</small
            ><small class="ca-error" *ngIf="row.error">{{ row.error }}</small
            ><a *ngIf="row.order_id" [routerLink]="['/orders/update', row.order_id]"
              >Заказ №{{ row.order_id }}</a
            ><a
              *ngIf="row.invoice_id"
              [routerLink]="['/docs/client_invoice/update', row.invoice_id]"
            >
              Счёт №{{ row.invoice_id }}</a
            >
          </div>
          <div class="ca-history-amount">
            <b>{{ row.amount | number: '1.2-2' }}</b
            ><small>{{
              row.channel === 'CASH'
                ? 'Наличные'
                : row.channel === 'BANK'
                ? 'Безнал'
                : 'Внутренний зачёт'
            }}</small
            ><small>Изменение {{ row.balance_delta | number: '1.2-2' }}</small
            ><small *ngIf="row.balance_after != null"
              >Баланс {{ row.balance_after | number: '1.2-2' }}</small
            >
          </div>
          <div class="ca-row-actions">
            <button mat-button *ngIf="row.id > 0" (click)="details(row)">
              {{ expanded.has(row.id) ? 'Свернуть' : 'Связи' }}</button
            ><button mat-button *ngIf="row.fiscal_status === 'BLOCKED'" (click)="retryReceipt(row)">
              Повторить чек</button
            ><ng-container *ngIf="isPendingBank(row)"
              ><button
                mat-stroked-button
                [disabled]="blocked"
                (click)="action('CONFIRM_BANK', row)"
              >
                Подтвердить банк</button
              ><button mat-button (click)="action('CANCEL_PENDING', row)">
                Отменить
              </button></ng-container
            ><button
              mat-button
              *ngIf="
                row.status === 'SUCCESS' &&
                (row.kind === 'ALLOCATE' || (isAdmin && row.kind === 'OPENING'))
              "
              [disabled]="blocked"
              (click)="action('REVERSE', row)"
            >
              Отменить зачёт
            </button>
          </div>
          <div
            class="ca-operation-details"
            *ngIf="expanded.has(row.id) && detailsById.get(row.id) as d"
          >
            <p *ngFor="let allocation of d.allocations">
              Счёт №{{ allocation.invoice_id
              }}<span *ngIf="allocation.order_id"> · заказ №{{ allocation.order_id }}</span
              >: зачтено {{ allocation.amount | number: '1.2-2' }}, освобождено
              {{ allocation.released | number: '1.2-2' }}
            </p>
            <p *ngFor="let source of d.sources">
              Источник: операция №{{ source.operation_id
              }}<span *ngIf="source.origin_payment_id">
                · оплата №{{ source.origin_payment_id }}</span
              ><span *ngIf="source.origin_return_id"> · возврат №{{ source.origin_return_id }}</span
              ><span *ngIf="source.fiscal_code"> · чек {{ source.fiscal_code }}</span>
            </p>
            <p *ngFor="let linked of d.related">
              {{ kindLabel(linked.kind) }} №{{ linked.id }} ·
              {{ linked.amount | number: '1.2-2' }} · {{ statusLabel(linked.status) }}
            </p>
            <p *ngFor="let receipt of d.receipts">
              Чек:
              {{
                receipt.fiscal_code ||
                  (receipt.status === 'BLOCKED' ? 'требует проверки' : 'ожидает исполнения')
              }}<span class="ca-error" *ngIf="receipt.error"> · {{ receipt.error }}</span>
            </p>
          </div>
        </article>
        <p class="ca-empty" *ngIf="!historyLoading && !historyError && !history.length">
          За выбранный период операций нет.
        </p>
      </div>
      <p class="ca-error" role="alert" *ngIf="historyError">
        {{ historyError }} <button mat-button (click)="loadHistory()">Повторить</button>
      </p>
      <div class="ca-footer">
        <span>Показано {{ history.length }} из {{ historyLength }}</span
        ><button mat-button *ngIf="hasMore" [disabled]="historyLoading" (click)="loadHistory()">
          Загрузить ещё
        </button>
      </div>
    </ng-container>
  </ng-container>
</section>
